export function getFinishCertMedia(imgUrl) {
  return {
    data: {},
    poster: imgUrl,
    type: 'photo',
    url: imgUrl,
    isCertificate: true
  };
}



/** WEBPACK FOOTER **
 ** ./utils/MediaUtil.js
 **/